/**
 * Цвет
 */
export enum TirPmStatusTextEnum {
  /**
   *  Позитив зеленый
   * */
  Default = "var(--text-inverted-primary)",
  /**
   *  Позитив зеленый
   * */
  Positive = "var(--status-positive)",
  /**
   * Предупреждение оранжевый
   */
  Attention = "var(--status-attention)",
  /**
   * Опасность красный
   */
  Negative = "var(--status-negative)",
  /**
   * Инфо голубой
   */
  Info = "var(--status-info)",
  /**
   * Нейтральный серый
   */
  Neutral = "var(--neutral-50)",
}
